import React from 'react';
import styled from 'styled-components';
import SvgIcon from '@/components/SvgIcon';

export default function LanguageSwitch({ option, onChange, currentTag }) {
  const onChangeValue = (v) => {
    onChange(v);
  };
  return (
    <Root>
      {option?.map((e) => (
        <Wrap
          className={currentTag === e.value ? 'tagForm active' : 'tagForm'}
          onClick={() => onChangeValue(e.value)}
          key={e.value}
        >
          <Box>
            <Img>
              <Image src={`${e.img}`} />
            </Img>
            <Title>{e.label}</Title>
          </Box>
          <Icon style={{ display: currentTag === e.value ? 'block' : 'none' }} type='checkbox' />
        </Wrap>
      ))}
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
`;

const Wrap = styled.div`
  &.tagForm {
    position: relative;
    box-sizing: border-box;
    width: 120px;
    height: 120px;
    border-radius: 6px;
    border: 2px;
    background: #f7f8fa;
    margin-top: 15px;
    margin-right: 30px;
    cursor: pointer;
  }
  &.active {
    border: 2px solid #194bff;
  }
`;

const Title = styled.div`
  width: 100%;
  height: 36px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  color: #0d111a;
`;

const Box = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Img = styled.div`
  height: 80px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  max-width: 45px;
  max-height: 45px;
  height: auto;
  width: auto;
`;

const Icon = styled(SvgIcon)`
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
`;
